import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

/**
 * Detects initial language from:
 *  1. URL search param  ?lang=fr  (mobile app deep-link)
 *  2. Hash-based param  #/path?lang=fr
 *  3. localStorage (returning visitor)
 *  4. Falls back to 'en'
 */
function detectLanguage() {
  // Check normal query string  ?lang=fr
  const urlParams = new URLSearchParams(window.location.search);
  const fromUrl = urlParams.get('lang');
  if (fromUrl === 'fr') return 'fr';

  // Check hash-based query string  #/path?lang=fr
  const hash = window.location.hash;
  const qIdx = hash.indexOf('?');
  if (qIdx !== -1) {
    const hashParams = new URLSearchParams(hash.slice(qIdx));
    const fromHash = hashParams.get('lang');
    if (fromHash === 'fr') return 'fr';
  }

  // Check localStorage
  const saved = localStorage.getItem('megatransact-lang');
  if (saved === 'fr') return 'fr';

  return 'en';
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(detectLanguage);

  useEffect(() => {
    localStorage.setItem('megatransact-lang', language);
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => setLanguage((l) => (l === 'en' ? 'fr' : 'en'));
  const isFr = language === 'fr';

  return (
    <LanguageContext.Provider value={{ language, isFr, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
